import { initGeneral } from "../modules/general.js";

jQuery(document).ready(function ($) {
	initGeneral();
});
